export default "../css/087551d9b161e691a2b4136aaba4af23.ttf";